import { render, staticRenderFns } from "./render_header.vue?vue&type=template&id=23ff0dc8&"
import script from "./render_header.vue?vue&type=script&lang=js&"
export * from "./render_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ff0dc8')) {
      api.createRecord('23ff0dc8', component.options)
    } else {
      api.reload('23ff0dc8', component.options)
    }
    module.hot.accept("./render_header.vue?vue&type=template&id=23ff0dc8&", function () {
      api.rerender('23ff0dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/render_fields/render_header.vue"
export default component.exports